import React, { useCallback, useContext } from 'react';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import { Button, RadioButtonField } from '@jutro/components';
import {
    SgNumberUtil, SgQuoteContext, SgCoveragesUtils, SgSubmissionUtil
} from 'saga-modules';

import messages from './SgAddon.messages';

function SgAddon(props) {
    const {
        modelVM,
        updateData,
        contentComponent,
        addon,
        onChange,
        // optional props
        subAddon,
        showToggle,
        showPrice,
        showAddition,
        showIncludedTick,
        isIncluded,
        includedLabel,
        priceOverride,
        priceTitle,
        selectLabel,
        removeLabel,
        contentMessages,
        contentJsx,
        path,
        onValidate: onValidateParent,
        showErrors,
        containerClass,
        showIcon,
        adobeValue,
        showMonthly,
        updateCoveragesAndCalculate
    } = props;

    const translator = useContext(TranslatorContext);
    const { quoting } = useContext(SgQuoteContext);
    const isMonthlySelected = showPrice && _.isNil(showMonthly) ? SgSubmissionUtil.isMonthlyPlanSelected(modelVM) : showMonthly;
    const addonPriceTitle = priceTitle || (isMonthlySelected ? messages.MonthlyPriceTitle : messages.DefaultPriceTitle);

    const changeToggleValue = useCallback((newValue) => {
        if (addon.selected !== newValue && !quoting) {
            onChange(addon, newValue);
        }
    }, [addon, onChange, quoting]);

    return (
        <div className={`sg-qnb-coverage-main ${addon.selected ? ' sgSelectedAddon' : ''} ${subAddon ? ' sgSubAddon' : ''} ${containerClass || ''}`}>
            <div className="sg-add-on-name-content-box">
                { contentComponent(
                    {
                        updateData,
                        modelVM,
                        addon,
                        contentMessages,
                        contentJsx,
                        path,
                        onValidateParent,
                        showErrors,
                        showIcon,
                        priceOverride,
                        updateCoveragesAndCalculate
                    }
                ) }
            </div>
            <div className="sg-add-on-name-price-box" id={`priceBox_${addon.patternCode}`}>
                { showPrice && (priceOverride || addon.amount)
                    && (
                        <>
                            <div
                                id={`coveragePriceWording_${addon.patternCode}`}
                                className="sg-addon-price-wording"
                            >
                                {translator(addonPriceTitle)}
                            </div>
                            <div id={`coveragePrice_${addon.patternCode}`} className="sg-addon-price">
                                { showAddition
                                && (
                                    <span>
                                        +
                                    </span>
                                )
                                }
                                <span>
                                    £
                                    {SgNumberUtil.getPriceInteger(priceOverride
                                        || SgCoveragesUtils.getCoveragePrice(addon.amount.annualAmount_Ext
                                            ? addon.amount.annualAmount_Ext : addon.amount.amount, modelVM, isMonthlySelected))}
                                </span>
                                <small>
                                    {SgNumberUtil.getPriceFraction(priceOverride
                                        || SgCoveragesUtils.getCoveragePrice(addon.amount.annualAmount_Ext
                                            ? addon.amount.annualAmount_Ext : addon.amount.amount, modelVM, isMonthlySelected))}
                                </small>
                            </div>
                        </>
                    )
                }
                { addon.selected
                    && (
                        <div id={`coverageIncludedTick_${addon.patternCode}`} className="sg-qnb-coverage-included">
                            { showIncludedTick ? <i className="mir mi-check green-tick" aria-hidden="true" /> : null }
                            <span>{ includedLabel && isIncluded ? translator(includedLabel) : translator(messages.Selected)}</span>
                        </div>
                    )
                }
                { showToggle
                    ? (
                        <RadioButtonField
                            id={`cov_coverage_${addon.patternCode}`}
                            className="sgBooleanRadioButtons"
                            dataType="string"
                            hideLabel
                            disabled={quoting}
                            onValueChange={(newVal) => changeToggleValue(newVal)}
                            showErrors={false}
                            value={addon.selected}
                        />
                    )
                    : !isIncluded && (
                        <Button
                            id={`cov_coverage_${addon.patternCode}`}
                            className={`sgButton sgPrimaryButton${addon.selected ? ' sgSecondaryGreenButton' : ''}`}
                            disabled={quoting}
                            onClick={() => onChange(addon)}
                            adobeValue={adobeValue}
                        >
                            {addon.selected ? translator(removeLabel) : translator(selectLabel)}
                        </Button>
                    )
                }
                { showPrice && isMonthlySelected && (priceOverride || addon.amount)
                && (
                    <>
                        <div id={`coveragePriceAnnual_${addon.patternCode}`} className="sg-addon-per-year-price">
                            <span>
                                {translator(messages.AnnualPriceWhenMonthly, { amount: SgNumberUtil.getFullPriceWithFraction(addon.amount.amount) })}
                            </span>
                            <small>
                                {translator(messages.PerYear)}
                            </small>
                        </div>
                    </>
                )
                }
            </div>
        </div>
    );
}

SgAddon.defaultProps = {
    selectLabel: messages.DefaultAddLabel,
    removeLabel: messages.DefaultRemoveLabel,
    showPrice: true,
    showToggle: false,
    showAddition: false,
    showIncludedTick: true
};

export default SgAddon;
